import {
  CreateRuleDialog,
  RulePresets,
} from '@/components/rules/dialogs/CreateRuleDialog';
import { Button } from '@/components/ui/button';
import { filterStore } from '@/state/transactions-filter-state';
import { filtersToRulePresets, TransactionFilters } from '@polybank/shared';
import {
  DropdownMenu,
  DropdownMenuTrigger,
  DropdownMenuContent,
  DropdownMenuLabel,
  DropdownMenuItem,
  DropdownMenuSeparator,
} from '@/components/ui/dropdown-menu';
import { Bookmark, Save, Sparkles, X } from 'lucide-react';
import { memo, useCallback, useState } from 'react';

export const SaveFiltersButton = memo(function SaveFiltersButton() {
  const [rulePresets, setRulePresets] = useState<RulePresets | undefined>();
  const [ruleDialogOpen, setRuleDialogOpen] = useState(false);
  const handleCreateRule = useCallback(() => {
    // Read directly from the mutable store to get the latest values
    const { triggers, actions } = filtersToRulePresets(
      filterStore.appliedFilters as TransactionFilters
    );
    setRulePresets({ triggers, actions });
    setRuleDialogOpen(true);
  }, []);

  return (
    <>
      <DropdownMenu>
        <DropdownMenuTrigger asChild>
          <Button
            size='sm'
            variant='outline'
            className='h-7 rounded-full px-3 text-xs border-dashed border-purple-200 dark:border-purple-800 bg-purple-50/50 dark:bg-purple-900/10 text-purple-700 dark:text-purple-300 hover:bg-purple-100 dark:hover:bg-purple-900/20 transition-colors'
          >
            <Save className='w-3.5 h-3.5 mr-1.5' />
            Save...
          </Button>
        </DropdownMenuTrigger>
        <DropdownMenuContent align='start' className='w-56'>
          <DropdownMenuLabel className='text-xs font-normal text-muted-foreground'>
            Actions for current filters
          </DropdownMenuLabel>
          <DropdownMenuItem onClick={() => alert('Coming soon')}>
            <Bookmark className='w-4 h-4 mr-2 text-blue-500' />
            <span>Save as Smart View</span>
          </DropdownMenuItem>
          <DropdownMenuItem onClick={handleCreateRule}>
            <Sparkles className='w-4 h-4 mr-2 text-purple-500' />
            <span>Create Auto-Rule</span>
          </DropdownMenuItem>
          <DropdownMenuSeparator />
          <DropdownMenuItem
            // onClick={() => {
            //   setFilters({
            //     description: '',
            //     dateFrom: undefined,
            //     dateTo: undefined,
            //     amountMin: '',
            //     amountMax: '',
            //     categories: [],
            //     type: 'all',
            //     tags: [],
            //     account: 'all',
            //   });
            //   if (onClearFilter) onClearFilter();
            // }}
            className='text-red-600 dark:text-red-400 focus:text-red-600 focus:bg-red-50 dark:focus:bg-red-900/10'
          >
            <X className='w-4 h-4 mr-2' />
            <span>Clear all filters</span>
          </DropdownMenuItem>
        </DropdownMenuContent>
      </DropdownMenu>
      <CreateRuleDialog
        open={ruleDialogOpen}
        onOpenChange={setRuleDialogOpen}
        presets={rulePresets}
      />
    </>
  );
});
